/*
  Scroll choreography:
  1. Reveal: elements with data-nuva-reveal fade-slide up when they enter the
     viewport, staggered by their data value. Elements already on screen at
     load are never hidden (no flash).
  2. Ingredient story: the [data-nuva-story] wrapper pins while scroll
     progress walks phases 1-3 (each card presents solo in the centre) and
     phase 4 (the trio settles side by side). Desktop only.
  Both disable under prefers-reduced-motion; without JS nothing is hidden.
*/
(function () {
  if (window.__nuvaScrollFx) return;
  window.__nuvaScrollFx = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // shared scroll-position read: Horizon scrolls .page-wrapper on desktop
  var nuvaWrapper = null;
  document.addEventListener('DOMContentLoaded', function () {
    nuvaWrapper = document.querySelector('.page-wrapper');
  });
  function nuvaScrollY() {
    return (window.pageYOffset || document.documentElement.scrollTop || 0)
      + (nuvaWrapper ? nuvaWrapper.scrollTop : 0);
  }

  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-nuva-reveal]'));
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('nuva-reveal-init');
          entry.target.classList.add('nuva-reveal-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    var vh = window.innerHeight;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) return; // already visible
      el.style.setProperty('--nuva-reveal-i', el.getAttribute('data-nuva-reveal') || '0');
      el.classList.add('nuva-reveal-init');
      io.observe(el);
    });
  }

  function initStory() {
    var pin = document.querySelector('[data-nuva-story]');
    if (!pin || reduceMotion) return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;

    pin.classList.add('nuva-story-active');
    pin.setAttribute('data-phase', '1');
    var last = '1';

    var lastY = null;
    function tick() {
      var y = nuvaScrollY();
      if (y === lastY) {
        window.requestAnimationFrame(tick);
        return;
      }
      lastY = y;
      var r = pin.getBoundingClientRect();
      var runway = r.height - window.innerHeight;
      if (runway > 0) {
        var p = Math.min(1, Math.max(0, -r.top / runway));
        pin.style.setProperty('--nuva-ip', p.toFixed(4));
        var phase = p < 0.5 ? '1' : p < 0.64 ? '2' : p < 0.78 ? '3' : '4';
        if (phase !== last) {
          last = phase;
          pin.setAttribute('data-phase', phase);
        }
      }
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function initFlavourScrub() {
    var pin = document.querySelector('[data-nuva-fc-scrub]');
    if (!pin || reduceMotion) return;
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    pin.classList.add('nuva-scrub-active');
    var grid = pin.querySelector('[data-nuva-reveal]');
    if (grid) grid.removeAttribute('data-nuva-reveal'); // scrub replaces the timed entrance

    /* Fast scrolling delivers big discrete jumps in scroll position; applying
       them directly makes the tubs teleport. The scroll position only sets a
       TARGET; the applied value eases toward it with a ~90ms time constant,
       so jumps become glides while the animation stays fully scroll-owned
       (stop scrolling and it settles; reverse and it follows back). Idle cost
       stays nil: once settled with no scroll change, no DOM reads or writes. */
    var lastY = null;
    var target = null;
    var current = null;
    var lastT = null;
    function tick(t) {
      var y = nuvaScrollY();
      if (y !== lastY) {
        lastY = y;
        var r = pin.getBoundingClientRect();
        var runway = r.height - window.innerHeight;
        if (runway > 0) target = Math.min(1, Math.max(0, -r.top / runway));
      }
      var dt = lastT === null ? 16.7 : Math.min(64, t - lastT);
      lastT = t;
      if (target !== null) {
        if (current === null) {
          current = target;
          pin.style.setProperty('--nuva-fcp', current.toFixed(4));
        } else if (current !== target) {
          var alpha = 1 - Math.exp(-dt / 90);
          var next = current + (target - current) * alpha;
          if (Math.abs(target - next) < 0.0004) next = target;
          current = next;
          pin.style.setProperty('--nuva-fcp', current.toFixed(4));
        }
      }
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function initHeroExit() {
    var hero = document.querySelector('[data-nuva-hero-exit]');
    if (!hero || reduceMotion) return;

    var lastY = null;
    function tick() {
      var y = nuvaScrollY();
      if (y === lastY) {
        window.requestAnimationFrame(tick);
        return;
      }
      lastY = y;
      var r = hero.getBoundingClientRect();
      if (r.height > 0) {
        var p = Math.min(1, Math.max(0, -r.top / (r.height * 0.85)));
        hero.style.setProperty('--nuva-hx', p.toFixed(4));
      }
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function initViewScrub() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-nuva-view-scrub]'));
    if (!els.length || reduceMotion) return;

    var lastY = null;
    function tick() {
      var y = nuvaScrollY();
      if (y === lastY) {
        window.requestAnimationFrame(tick);
        return;
      }
      lastY = y;
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        // 0 when the element's top touches the viewport bottom; 1 once it
        // has risen 45% of the viewport
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.45)));
        els[i].style.setProperty('--nuva-vp', p.toFixed(4));
      }
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function start() {
    initViewScrub();
    initHeroExit();
    initFlavourScrub();
    initReveal();
    initStory();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
